import React, { Component, PropTypes } from 'react'
import { Loader } from 'semantic-ui-react'

import './../../node_modules/semantic-ui-css/components/loader.css'

export default class asyncImageLoader extends Component {

  static propTypes = {
    loaderSize: PropTypes.string,
  }

  render () {
    const { loaderSize } = this.props
    return (
      <div>
        <Loader
          active
          className={loaderSize}
          inverted
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/asyncImages/LoaderComponent.js